import FormColorsMenu from 'components/forms/form-colors';
import FormInput from 'components/forms/form-input';
import FormRichTextEditor from 'components/forms/form-rich-text.editor';
import { ShimmerLabel } from 'components/shimmer/utils';
import InputFormShimmer from 'pages/users/funnels/shimmers/site-labels/input-form';
import React from 'react';
import { get, snakeToCapitalize } from './helpers';

export const renderLabels = (mergedLabels, isLoading) => {
  const componentsArray = new Set();

  /**
   * recursively loops to a json file and render them, accepts only objects and string types
   * @param object
   * @param parent
   */
  const renderHeaderOrInput = (object, parent: Array<any> = []) => {
    for (const property in object) {
      const currentProperty = object[property];
      const name = parent.length > 0 ? [parent, property].join('.') : [property].join('.');

      if (typeof currentProperty === 'object') {
        const header = (
          <>
            <div className="font-semibold p-4 bg-gray-100 rounded-md">
              {isLoading ? <ShimmerLabel width="w-1/6" /> : snakeToCapitalize(property)}
            </div>
          </>
        );
        componentsArray.add({ component: header, key: property });
        renderHeaderOrInput(currentProperty, [...parent, property]);
      } else if (property.endsWith('Color')) {
        const field = <FormColorsMenu name={name} label={snakeToCapitalize(property)} />;

        componentsArray.add({ component: field, key: name });
      } else if (property.toLowerCase().endsWith('description')) {
        const field = <FormRichTextEditor label={snakeToCapitalize(property)} name={name} />;

        componentsArray.add({ component: field, key: name });
      } else if (typeof currentProperty === 'string') {
        const placeholder = get(mergedLabels, name);
        const fields = isLoading ? (
          <InputFormShimmer />
        ) : (
          <FormInput key={name} name={name} label={snakeToCapitalize(property)} placeholder={placeholder} />
        );

        componentsArray.add({ component: fields, key: name });
      } else {
        throw new Error('Invalid header input');
      }
    }
    return [...Array.from(componentsArray)];
  };

  return renderHeaderOrInput(mergedLabels);
};
